<template>
    <client-action-modal
        :show.sync="visible"
        :client-action-id="$route.params.clientActionId"
    >
    </client-action-modal>
</template>

<script>
import ClientActionModal from '@/components/Action/Modal/ClientActionModal';
import ActionStatus from "@/services/Action/ActionStatus";

export default {
  name: 'ClientActionPage',
  components: {
    ClientActionModal,
  },
  data() {
    return {
      visible: true,
      previousRoute: null,
    };
  },
  computed: {
    statusFilter() {
      return this.$store.getters.actionStatusFilter;
    },
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.previousRoute = from;
    });
  },
  watch: {
    /**
     * We're watching to see when the modal closes
     * When it does, we want to redirect it to the correct url
     * @param newVisible
     */
    visible(newVisible) {
      if (!newVisible) {
        const route = {
          name: 'clientActions',
        };
        if (this.statusFilter) {
          const routePath = ActionStatus.getRouteByStatus(this.statusFilter);

          route.name = 'clientActionStatus';
          route.params = {
            statusFilter: routePath,
          };
        }

        this.$router.push(route);
      }
    },
  },
  methods: {
  },
};
</script>
